export enum WaitSpinnerVariant {
    cloud = 'cloud',
    small = 'small',
    inline = 'inline',
}
